import React, { useEffect, useRef } from 'react';
import scriptjs from 'scriptjs';
import PropTypes from 'prop-types';

let loading = false;
const LoginBranding = (props) => {
    const { theme, config } = props;
    const { experienceServiceUIBaseUrl } = config ?? {};
    const rootEl = useRef();

    useEffect(() => {
        if (theme && experienceServiceUIBaseUrl && rootEl.current && !loading) {
            const rootElement = rootEl.current.parentNode;

            const { attributes = [] } = theme;
            (attributes ?? []).forEach((attrParam) => {
                const attr = attrParam;

                if (attr && attr.value && typeof attr.value !== 'string') {
                    attr.value = attr.value.toString();
                }
            });

            loading = true;

            scriptjs(
                `${experienceServiceUIBaseUrl}/branding/static/js/UIFlexibilityBranding.js`,
                () => {
                    if (typeof window.UIFlexibilityBranding !== 'undefined') {
                        window.UIFlexibilityBranding.applyBrandingConfig(
                            theme,
                            theme.themeId,
                            rootElement,
                            'style,link',
                        );
                    }
                },
            );
        }
    }, [theme, experienceServiceUIBaseUrl, rootEl.current]);

    if (!experienceServiceUIBaseUrl || !theme) {
        return false;
    }

    return (
        <div ref={rootEl}>
            <link
                rel="stylesheet"
                href={`${experienceServiceUIBaseUrl}/branding/static/css/UIFlexibilityBranding.css`}
            />
        </div>
    );
};

LoginBranding.propTypes = {
    theme: PropTypes.instanceOf(Object),
    config: PropTypes.instanceOf(Object),
};

export default LoginBranding;
